import React from 'react';

function OrganizationCard({ organization, onSelect, onUpdate, onDelete }) {
  return (
    <div className="organization-card" onClick={onSelect}>
      <div className="organization-card-header">
        <h3>{organization.name}</h3>
      </div>
      
      <div className="organization-card-content">
        {organization.description && (
          <div className="organization-description">
            {organization.description}
          </div>
        )}
      </div>
      
      <div className="organization-card-actions">
        <button 
          className="view-organization-button"
          onClick={onSelect}
        >
          Teams anzeigen
        </button>
        
        {onUpdate && (
          <button 
            className="edit-organization-button"
            onClick={(e) => {
              e.stopPropagation();
              onUpdate();
            }}
          >
            Bearbeiten
          </button>
        )}
        
        {onDelete && (
          <button 
            className="delete-organization-button"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            Löschen
          </button>
        )}
      </div>
    </div>
  );
}

export default OrganizationCard;